import { render } from "./UserProfile.vue?vue&type=template&id=74e14b5f"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=74e14b5f&lang=css"

import exportComponent from "C:\\Users\\Administrator.1LIZRQUYRIVXOVB\\github-classroom\\MUICCS\\cs340prj-Atiwat-R\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__